module.exports = require("moment/locale/es-mx.js");